// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__7THzs","rightAdornment":"Header_rightAdornment__2MnQd"};